export enum ListItemType {
  Bill,
  Maintenance
}
